/*  */
import type { RouteRecordRaw } from 'vue-router';
import MyRep from './MyRep.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import { RouteNames } from '@/router/routeNames';

const routes: RouteRecordRaw = {
  path: '/rep',
  component: DashboardLayout,
  children: [
    {
      name: RouteNames.MY_REP,
      path: '',
      component: MyRep,
      meta: {
        pageTitle: 'Policy.Rep',
        indexOfRoute: 0,
      },
    },
  ],
};

export default routes;
